import { IMockProps, ErrorResponseCodeType } from '_core/types';
import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/MemberDef';

const autoGenerateSuccess = () => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data: {
        member: {
          memberNumber: '718817842',
          firstName: 'José',
          lastName: 'Silva',
          birthDay: '1985-12-21',
          gender: 'MALE',
          citizenship: 'Brazilian',
          memberType: 'Individual',
          availableMiles: '3587',
          milesToExpire: '187',
          milesNextExpirationDate: '2023-07-09T17:48:24',
          owner: 'Owner',
          category: 'Smiles',
          status: 'ACTIVE',
          memberSince: '2001-07-11T03:00:00',
          addressList: [
            {
              preferential: true,
              type: 'HOME',
              streetName: 'Rua do teste',
              streetNumber: '12A',
              complement: 'Próximo ao mercado',
              zipCode: '07123287',
              city: 'Guarulhos',
              state: 'SP',
              country: 'Brazil',
            },
          ],
          phoneList: [
            {
              type: 'HOME',
              internationalCode: '55',
              areaCode: '11',
              number: '24859874',
            },
            {
              type: 'CELLULAR',
              internationalCode: '55',
              areaCode: '11',
              number: '912345678',
            },
          ],
          documentList: [
            {
              type: 'CPF',
              number: '26823280085',
            },
            {
              type: 'RG',
              number: '12345678',
            },
          ],
          electronicAddressList: [
            {
              preferential: true,
              address: 'smiles@smiles.com',
            },
            {
              preferential: false,
              address: 'teste@smiles.com',
            },
          ],
          role: "P1=WS05;PM=Y;CF=M;TD=0'",
          isClubMember: true,
          isMgmMember: false,
          lastLogin: '2021-01-20T13:25:17Z',
          allowPromoEmail: true,
          allowMail: true,
          allowSMS: true,
          allowCall: false,
          language: 'Português',
          isFamilyAccount: false,
          sendAccrualRdmEmail: false,
          programName: 'Programa Smiles',
          iva: '47428B-1',
          socialIdNumber: 'fdg546r5s5s85asfth',
          socialIdProvider: 'facebook',
          lastUpdateDate: '2021-01-20T10:25:17',
          statusCobranded: 'NA',
        },
      },
    },
  };
  return validateSuccess;
};

const autoGenerateSuccessToken = autoGenerateSuccess();

const generatedSuccessMocks = [autoGenerateSuccessToken];

const autoGenerate = () => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body: {},
        },
        configResponse: {
          status: 500,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate();
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const GetMember = [...generatedSuccessMocks, ...errorsGenerated];
export default GetMember;
